export default function debugWallet(...args) {
    if (typeof window !== 'undefined') {
        const { searchParams } = new URL(window.location.href);
        const isDebugMode = searchParams.get('debugWallet');

        if (isDebugMode) {
            const filteredArgs = args.filter((arg) => typeof arg !== 'function');
            const now = new Date();
            const formattedDate = now.toISOString();

            if (args[0] === 'UDS') {
                // eslint-disable-next-line no-console
                console.log(`[${formattedDate}] UDS: `, ...filteredArgs);
            } else {
                // eslint-disable-next-line no-console
                console.log(`[${formattedDate}] WALLET: `, ...filteredArgs);
            }
        }
    }
}
